import { FormControl } from 'baseui/form-control'
import { SIZE, MODE } from 'baseui/button-group'
import SDButtonGroup from '@/shared/components/SDComponents/SDButtonGroup/SDButtonGroup'
import SDButtonGroupButton from '@/shared/components/SDComponents/SDButtonGroup/SDButtonGroupButton'

interface GenericButtonGroupProps {
  selected: number[] | undefined
  onClick: (event: React.SyntheticEvent, index: number) => void
  label: string
  values: string[]
}

const GenericButtonGroup = ({ selected, onClick, label, values }: GenericButtonGroupProps) => {
  return (
    <FormControl label={label}>
      {/* @ts-expect-error SDButtonGroup is a JS component without proper TS types */}
      <SDButtonGroup mode={MODE.radio} size={SIZE.mini} selected={selected} onClick={onClick}>
        {values.map((value, index) => (
          // @ts-expect-error SDButtonGroupButton is a JS component without proper TS types
          <SDButtonGroupButton key={index}>{value}</SDButtonGroupButton>
        ))}
      </SDButtonGroup>
    </FormControl>
  )
}

export default GenericButtonGroup
